<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">
            TOP > シミュレーション > お届け先入力 > 確認ページ
          </div>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <div class="container mt-5 confirmation-main">
      <h2 class="text-center text-color-fff">ご注文内容の確認</h2>
      <!-- お届け先情報 -->
      <div class="card">
        <div class="card-body">
          <h4>お届け先</h4>
          <table class="delivery-info">
            <tbody>
              <tr>
                <th>お名前:</th>
                <td>{{ formData.name }}</td>
              </tr>
              <tr>
                <th>お名前（かな）:</th>
                <td>{{ formData.nameKana }}</td>
              </tr>
              <tr>
                <th style="vertical-align: top">ご住所:</th>
                <td>
                  {{ formData.postcode }}<br />
                  {{ formData.prefecture }} {{ formData.city }}
                  {{ formData.street }}<br />
                  {{ formData.building }}
                </td>
              </tr>

              <tr>
                <th>電話番号:</th>
                <td>{{ formData.phone }}</td>
              </tr>
              <tr>
                <th>メールアドレス:</th>
                <td>{{ formData.email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 商品情報 -->
      <div class="card mt-4">
        <div class="card-body">
          <h4>商品情報</h4>
          <div class="form-original">
            シミュレーションID:&nbsp;{{ sessionID }}
          </div>
          <div class="shop-name" v-if="formData.shop || formData.otherShop">
            <p>
              販売店名:&nbsp;{{ formData.shop === "other" ? formData.otherShop : shopName }}
            </p>
          </div>
          <div class="choice-detail">
            <table cellpadding="10">
              <thead>
                <tr>
                  <th class="confir-border-right">商品名</th>
                  <th>価格</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td class="confir-border-right">グローブ本体</td>
                  <td class="table-price">{{ baseCost.toLocaleString() }}円</td>
                </tr>

                <tr>
                  <td class="confir-border-right">オプション</td>
                  <td class="table-price">
                    <!-- tax抜き合計 - baseCost -->
                    {{ optionCost.toLocaleString() }}円
                  </td>
                </tr>
                <tr>
                  <td class="confir-border-right">
                    <!-- <details>
                      <summary>詳細を見る</summary> -->
                      <p>形状</p>
                      <ul>
                        <li>
                          モデル選択: {{ selected.modelChoice || "未選択" }}
                        </li>
                        <li>ポジション: {{ selected.position || "未選択" }}</li>
                        <li>型名: {{ selected.typeName || "未選択" }}</li>
                        <li>
                          グラブの左右: {{ selected.gloveHand || "未選択" }}
                        </li>
                        <li>
                          バックスタイル: {{ selected.backStyle || "未選択" }}
                        </li>
                        <li
                          v-if="
                            selected.backStyle ===
                            'ライナーバック'
                          "
                        >
                          ラベルの位置:
                          {{ selected.labelPosition || "未選択" }}
                        </li>
                        <li>ベルト型: {{ selected.beltType || "未選択" }}</li>
                        <li>
                          サイズ調整: {{ selected.fingerSize || "未選択" }}
                        </li>
                        <li>
                          背面ひも通し: {{ selected.backStrand || "未選択" }}
                        </li>
                        <li>
                          ハミダシ: {{ selected.hamidashiChoice || "未選択" }}
                        </li>
                        <li>トジ部: {{ selected.lacePortion || "未選択" }}</li>
                        <li>
                          トジ部のヒモ通し:
                          {{ selected.laceStrand || "未選択" }}
                        </li>
                        <li>ウェブ: {{ selected.web || "未選択" }}</li>
                        <li>
                          指カバー・指アテ: {{ selected.finger || "未選択" }}
                        </li>
                      </ul>

                      <p>カラー</p>
                      <ul>
                        <li>
                          本体カラー: {{ selected.mainColor || "未選択" }}
                        </li>

                          <template v-if="selected.backStyle == 'レギュラー'">
                            <li>
                              親指 外側カラー: {{ selected.thumbOut || "未選択" }}
                            </li>
                            <li>
                              親指 内側カラー: {{ selected.thumbIn || "未選択" }}
                            </li>
                            <li>
                              人差し指 外側カラー:
                              {{ selected.indexFingerOut || "未選択" }}
                            </li>
                            <li>
                              人差し指 内側カラー:
                              {{ selected.indexFingerIn || "未選択" }}
                            </li>
                            <li>
                              中指 外側カラー:
                              {{ selected.middleFingerOut || "未選択" }}
                            </li>
                            <li>
                              中指 内側カラー:
                              {{ selected.middleFingerIn || "未選択" }}
                            </li>
                            <li>
                              薬指 外側カラー:
                              {{ selected.thirdFingerOut || "未選択" }}
                            </li>
                            <li>
                              薬指 内側カラー:
                              {{ selected.thirdFingerIn || "未選択" }}
                            </li>
                            <li>
                              小指 外側カラー:
                              {{ selected.littleFingerOut || "未選択" }}
                            </li>
                            <li>
                              小指 内側カラー:
                              {{ selected.littleFingerIn || "未選択" }}
                            </li>
                          </template>

                          <template v-if="selected.backStyle == '王冠'">
                            <li>
                              親指 外側カラー: {{ selected.thumbOut || "未選択" }}
                            </li>
                            <li>
                              親指 内側カラー: {{ selected.thumbIn || "未選択" }}
                            </li>
                            <li>
                              人差し指 内側カラー:
                              {{ selected.indexFingerIn || "未選択" }}
                            </li>
                            <li>
                              人差し指 外側・中指 内側カラー:
                              {{ selected.indexAndMiddleFinger || "未選択" }}
                            </li>
                            <li>
                              中指 外側・薬指 内側カラー:
                              {{ selected.middleAndThirdFinger || "未選択" }}
                            </li>
                            <li>
                              薬指 外側・小指 内側カラー:
                              {{ selected.thirdAndLittleFinger || "未選択" }}
                            </li>
                            <li>
                              小指 外側カラー:
                              {{ selected.littleFingerOut || "未選択" }}
                            </li>
                          </template>

                          <template v-if="selected.backStyle == 'ライナーバック'">
                            <li>
                              親指 外側カラー: {{ selected.thumbOut || "未選択" }}
                            </li>
                            <li>
                              親指 内側・人差し指・中指 内側カラー: {{ selected.thumbIndexAndMiddleFinger || "未選択" }}
                            </li>
                            <li>
                              中指 外側・薬指 内側カラー: {{ selected.middleAndThirdFinger || "未選択" }}
                            </li>
                            <li>
                              薬指 外側・小指 内側カラー:
                              {{ selected.thirdAndLittleFinger || "未選択" }}
                            </li>
                            <li>
                              小指 外側カラー:
                              {{ selected.littleFingerOut || "未選択" }}
                            </li>
                          </template>
                          
                        <li>バンド: {{ selected.bandColor || "未選択" }}</li>
                        <li>捕球面: {{ selected.catchColor || "未選択" }}</li>
                        <li>
                          親指掛け: {{ selected.thumbHanger || "未選択" }}
                        </li>
                        <li>
                          小指掛け:
                          {{ selected.littleFingerHanger || "未選択" }}
                        </li>
                        <li>ヘリ革: {{ selected.hemLeather || "未選択" }}</li>
                        <li>
                          ウェブ背面側・タテ棒:
                          {{ selected.webBack || "未選択" }}
                        </li>
                        <li>
                          ウェブ捕球面側・ヨコ棒:
                          {{ selected.webCatch || "未選択" }}
                        </li>
                        <li>
                          ウェブエッジ・その他:
                          {{ selected.webEdge || "未選択" }}
                        </li>
                        <li>平裏: {{ selected.hiraura || "未選択" }}</li>
                        <li
                          v-if="
                              selected.beltType ===
                              'Tベルト'
                            "
                        >
                          トレジャーベルト:
                          {{ selected.treasureBelt || "未選択" }}
                        </li>
                        <li
                          v-if="
                              selected.backStyle ===
                              'ライナーバック'
                            "
                        >
                          ライナーバックベルト:
                          {{ selected.linerBackBeltColor || "未選択" }}
                        </li>
                        <li v-if="selected.finger !== 'なし' && selected.backStyle !== 'ライナーバック'">
                          指カバー・指アテ:
                          {{ selected.fingerCoverColor || "未選択" }}
                        </li>
                        <li v-if="selected.hamidashiChoice === '切はみ'">
                          {{ dynamicHamidashiLabel }}:
                          {{ selected.additional || "未選択" }}
                        </li>
                        <li v-if="selected.hamidashiChoice === '玉はみ'">
                          {{ dynamicHamidashiLabel }}:
                          {{ selected.additional || "未選択" }}
                        </li>

                        <li>レース: {{ selected.laceColor || "未選択" }}</li>
                        <li>
                          ステッチ: {{ selected.stitchColor || "未選択" }}
                        </li>
                        <li>
                          トレジャーラベル:
                          {{ selected.treasureLabelChoice || "未選択" }}
                        </li>
                        <li
                          v-if="
                            selected.treasureLabelChoice ===
                            'オリジナル（+3,300円&納期+30日）'
                          "
                        >
                          メインカラー:
                          {{ selected.optionMainColor || "未選択" }}
                        </li>
                        <li
                          v-if="
                            selected.treasureLabelChoice ===
                            'オリジナル（+3,300円&納期+30日）'
                          "
                        >
                          カゲカラー:
                          {{ selected.optionShadowColor || "未選択" }}
                        </li>
                        <li
                          v-if="
                            selected.treasureLabelChoice ===
                            'オリジナル（+3,300円&納期+30日）'
                          "
                        >
                          台カラー: {{ selected.optionStandColor || "未選択" }}
                        </li>
                      </ul>

                      <div class="form-original">
                        オリジナルラベル:&nbsp;{{ formData.original }}
                      </div>

                      <p>刺繍</p>
                      <ul v-if="savedSelections.length">
                        <li
                          v-for="(selection, index) in savedSelections"
                          :key="index"
                        >
                          <p>刺繍設定 {{ index + 1 }}</p>
                          <ul>
                            <li>
                              刺繍位置:
                              {{ selection.embroideryPosition || "未選択" }}
                            </li>
                            <li>書体: {{ selection.font || "未選択" }}</li>
                            <li>
                              書体カラー: {{ selection.fontColor || "未選択" }}
                            </li>
                            <li>
                              カゲ・フチ: {{ selection.shadowEdge || "未選択" }}
                            </li>
                            <li v-if="selection.shadowEdge === 'カゲ'">
                              カゲカラー:
                              {{ selection.shadowColor || "未選択" }}
                            </li>
                            <li v-if="selection.shadowEdge === 'フチ'">
                              フチカラー: {{ selection.edgeColor || "未選択" }}
                            </li>
                            <li>
                              刺繍内容:
                              {{ selection.embroideryContent || "未入力" }}
                            </li>
                          </ul>
                        </li>
                      </ul>
                    <!-- </details> -->
                  </td>
                </tr>
                <tr>
                  <td class="confir-border-right">送料</td>
                  <td class="table-price">0円</td>
                </tr>
                <tr>
                  <td class="confir-border-right">税率(10%)</td>
                  <td class="table-price">
                    {{ taxAmount.toLocaleString() }}円
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td
                    colspan="2"
                    style="border-top: 1px solid"
                    class="table-price"
                  >
                    <!-- OrderPage.vue での totalPrice（税込）をそのまま表示 -->
                    合計金額 {{ totalPrice.toLocaleString() }}円
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="table-price">
                    <!-- 税抜き金額 totalPriceNoTax -->
                    税抜金額 {{ totalPriceNoTax.toLocaleString() }}円
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="mt-4 text-color-fff">
            <p class="confirmation-caution">
              お支払い方法について
              <br />
              ご注文手続き完了後、1週間以内に下記振込先へお振込をお願いいたします。
              <br />
              なお、1週間以内のお振込が確認できない場合はご注文をキャンセルさせていただきますのでご了承ください。
            </p>
            <p class="confirmation-caution">
              納期および商品の発送について
              <br />
              納期は通常6ヶ月程度を予定しております。また、受注状況により納期が異なる場合がございますのでご了承ください。
              <br />
              発送準備が出来次第、ご登録のメールアドレスへ「商品発送のご案内」メールをお送りいたします。
            </p>
          </div>
          <div class="mt-4 text-color-fff">
            <p class="confirmation-caution">
              ご注文をもって、<router-link :to="{ name: 'TermsOfService' }" class="privacy-link">利用規約</router-link>および<router-link :to="{ name: 'PrivacyPolicy' }" class="privacy-link">プライバシーポリシー</router-link>に同意したものとみなします。
            </p>
            <p class="confirmation-caution">
              <router-link :to="{ name: 'SpecifiedCommercialTransactions' }" class="privacy-link">特定商取引法に基づく表記</router-link>はこちら
            </p>
          </div>
          <!-- ボタン -->
          <div class="form-row mt-4 form__btn_gap">
            <div class="col">
              <button
                type="button"
                @click="$router.back()"
                class="form-btn-block form-btn-secondary btn btn-secondary btn-block"
              >
                戻る
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="form-btn-block form-btn-secondary btn btn-primary btn-block"
                :disabled="sending"
                @click="confirmOrder"
              >
                {{ sending ? "送信中..." : "注文を確定する" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendMail, MAIL_TYPES } from "../utils/mailer";

export default {
  name: "ConfirmationPage",
  data() {
    return {
      formData: {
        name: "",
        nameKana: "",
        postcode: "",
        prefecture: "",
        city: "",
        street: "",
        building: "",
        phone: "",
        email: "",
        original: "",
      },
      selected: {}, // ローカルストレージから取得するデータ
      totalPrice: 0,
      savedSelections: [],
      sessionID: "",
      sending: false,
    };
  },
  created() {
    // sessionStorageから住所などのデータを取得
    Object.keys(this.formData).forEach((key) => {
      this.formData[key] = sessionStorage.getItem(key) || "";
    });

    // shop と otherShop を個別に取得
    this.formData.shop = sessionStorage.getItem("shop") || "";
    this.formData.otherShop = sessionStorage.getItem("otherShop") || "";

    // sessionStorageから選択データを取得
    const selectedData = sessionStorage.getItem("selectedData");
    if (selectedData) {
      this.selected = JSON.parse(selectedData);
    } else {
      this.selected = {}; // 選択データが存在しない場合、空オブジェクトをセット
    }

    // ★ sessionStorage から totalPrice を取得
    const savedTotalPrice = sessionStorage.getItem("totalPrice");
    if (savedTotalPrice) {
      this.totalPrice = parseInt(savedTotalPrice, 10);
    }

    // ★ここを追加：刺繍設定を sessionStorage から取得
    const savedSelectionsString = sessionStorage.getItem("savedSelections");
    if (savedSelectionsString) {
      this.savedSelections = JSON.parse(savedSelectionsString);
    } else {
      this.savedSelections = [];
    }

    // sessionID を sessionStorage から取得
    this.sessionID = sessionStorage.getItem("sessionID") || "未発行";
  },

  computed: {
    // 動的なラベル
    dynamicHamidashiLabel() {
      if (this.selected?.hamidashiChoice === "切はみ") {
        return "ハミダシ:切はみカラー";
      } else if (this.selected?.hamidashiChoice === "玉はみ") {
        return "ハミダシ:玉はみカラー";
      }
      return "ハミダシを選択してください";
    },

    // グローブ本体価格
    baseCost() {
      if (!this.selected?.modelChoice) return 0;
      if (this.selected.modelChoice.includes("硬式用")) return 70000;
      if (this.selected.modelChoice.includes("軟式用")) return 60000;
      return 0;
    },

    // 税抜き金額 = totalPrice を 1.1 で割って、.toFixed(0) を使う
    totalPriceNoTax() {
      if (!this.totalPrice) return 0; // totalPrice が 0 のときは 0

      // まずは割り算を行って小数が出る
      const noTaxFloat = this.totalPrice / 1.1;

      // .toFixed(0) で小数点以下を四捨五入 → 文字列
      // Number(...) で文字列を数値に再変換
      return Number(noTaxFloat.toFixed(0));
    },

    // オプション金額 = 税抜き合計 - グローブ本体価格
    optionCost() {
      // どちらかが未定義なら 0
      return (this.totalPriceNoTax || 0) - (this.baseCost || 0);
    },

    // 「税率(10%)」と表示したい項目 → 「合計金額（税込） - 税抜き金額」
    taxAmount() {
      // totalPrice も totalPriceNoTax も整数になっているはず
      // （上記で .toFixed(0) にしているから）
      return this.totalPrice - this.totalPriceNoTax;
    },


    shopName() {
      // 販売店名マッピング（キー: 値）
      const shopMap = {
        "shop-a": "販売店A",
        "shop-b": "販売店B",
        "shop-c": "販売店C",
      };
      return shopMap[this.formData.shop] || "その他";
    },

    // メール本文に載せる注文内容のテキスト（画面表示と同じ内容をテキスト化）
    // 下記以外の内容については、emailjsのEmail Templatesからメールの本文を編集する必要がある。
    // https://dashboard.emailjs.com/admin/templates
    
    orderDetailsText() {
      const s = this.selected || {};
      const lines = [];
      const push = (label, value) => {
        lines.push(`${label}: ${value || "未選択"}`);
      };

      lines.push("■形状");
      push("　モデル選択", s.modelChoice);
      push("　ポジション", s.position);
      push("　型名", s.typeName);
      push("　グラブの左右", s.gloveHand);
      push("　バックスタイル", s.backStyle);
      if (s.backStyle === "ライナーバック") {
        push("　ラベルの位置", s.labelPosition);
      }
      push("　ベルト型", s.beltType);
      push("　サイズ調整", s.fingerSize);
      push("　背面ひも通し", s.backStrand);
      push("　ハミダシ", s.hamidashiChoice);
      push("　トジ部", s.lacePortion);
      push("　トジ部のヒモ通し", s.laceStrand);
      push("　ウェブ", s.web);
      push("　指カバー・指アテ", s.finger);

      lines.push("");
      lines.push("■カラー");
      push("　本体カラー", s.mainColor);

      if (s.backStyle === "レギュラー") {
        push("　親指 外側カラー", s.thumbOut);
        push("　親指 内側カラー", s.thumbIn);
        push("　人差し指 外側カラー", s.indexFingerOut);
        push("　人差し指 内側カラー", s.indexFingerIn);
        push("　中指 外側カラー", s.middleFingerOut);
        push("　中指 内側カラー", s.middleFingerIn);
        push("　薬指 外側カラー", s.thirdFingerOut);
        push("　薬指 内側カラー", s.thirdFingerIn);
        push("　小指 外側カラー", s.littleFingerOut);
        push("　小指 内側カラー", s.littleFingerIn);
      } else if (s.backStyle === "王冠") {
        push("　親指 外側カラー", s.thumbOut);
        push("　親指 内側カラー", s.thumbIn);
        push("　人差し指 内側カラー", s.indexFingerIn);
        push("　人差し指 外側・中指 内側カラー", s.indexAndMiddleFinger);
        push("　中指 外側・薬指 内側カラー", s.middleAndThirdFinger);
        push("　薬指 外側・小指 内側カラー", s.thirdAndLittleFinger);
        push("　小指 外側カラー", s.littleFingerOut);
      } else if (s.backStyle === "ライナーバック") {
        push("　親指 外側カラー", s.thumbOut);
        push("　親指 内側・人差し指・中指 内側カラー", s.thumbIndexAndMiddleFinger);
        push("　中指 外側・薬指 内側カラー", s.middleAndThirdFinger);
        push("　薬指 外側・小指 内側カラー", s.thirdAndLittleFinger);
        push("　小指 外側カラー", s.littleFingerOut);
      }

      push("　バンド", s.bandColor);
      push("　捕球面", s.catchColor);
      push("　親指掛け", s.thumbHanger);
      push("　小指掛け", s.littleFingerHanger);
      push("　ヘリ革", s.hemLeather);
      push("　ウェブ背面側・タテ棒", s.webBack);
      push("　ウェブ捕球面側・ヨコ棒", s.webCatch);
      push("　ウェブエッジ・その他", s.webEdge);
      push("　平裏", s.hiraura);

      if (s.beltType === "Tベルト") {
        push("　トレジャーベルト", s.treasureBelt);
      }
      if (s.backStyle === "ライナーバック") {
        push("　ライナーバックベルト", s.linerBackBeltColor);
      }
      if (s.finger !== "なし" && s.backStyle !== "ライナーバック") {
        push("　指カバー・指アテ", s.fingerCoverColor);
      }
      if (s.hamidashiChoice === "切はみ") {
        push("　切はみカラー", s.additional);
      } else if (s.hamidashiChoice === "玉はみ") {
        push("　玉はみカラー", s.additional);
      }

      push("　レース", s.laceColor);
      push("　ステッチ", s.stitchColor);
      push("　トレジャーラベル", s.treasureLabelChoice);
      if (s.treasureLabelChoice === "オリジナル（+3,300円&納期+30日）") {
        push("　メインカラー", s.optionMainColor);
        push("　カゲカラー", s.optionShadowColor);
        push("　台カラー", s.optionStandColor);
      }

      if (this.savedSelections.length) {
        lines.push("");
        lines.push("■刺繍");
        this.savedSelections.forEach((selection, index) => {
          lines.push("　刺繍設定" + (index + 1));
          push("　　刺繍位置", selection.embroideryPosition);
          push("　　書体", selection.font);
          push("　　書体カラー", selection.fontColor);
          push("　　カゲ・フチ", selection.shadowEdge);
          if (selection.shadowEdge === "カゲ") {
            push("　　カゲカラー", selection.shadowColor);
          }
          if (selection.shadowEdge === "フチ") {
            push("　　フチカラー", selection.edgeColor);
          }
          push("　　刺繍内容", selection.embroideryContent || "未入力");
          lines.push("");
        });
      }

      return lines.join("\n");
    },
  },

  methods: {
    async confirmOrder() {
      this.sending = true;
      try {
        const templateParams = {
          customer_name: this.formData.name,
          customer_name_kana: this.formData.nameKana,
          email: this.formData.email,
          phone: this.formData.phone,
          postcode: this.formData.postcode,
          address: `${this.formData.prefecture}${this.formData.city}${this.formData.street} ${this.formData.building}`,
          shop_name:
            this.formData.shop === "other"
              ? this.formData.otherShop
              : this.shopName,
          original: this.formData.original,
          session_id: this.sessionID,
          total_price: this.totalPrice.toLocaleString(),
          total_price_no_tax: this.totalPriceNoTax.toLocaleString(),
          tax_amount: this.taxAmount.toLocaleString(),
          order_details: this.orderDetailsText,
        };

        const apiUrl = process.env.VUE_APP_SIMULATION_API_URL;

        const orderDataToSave = {
          // OrderPageが復元に使うデータ
          selected: this.selected,
          selection: this.selection,
          savedSelections: this.savedSelections,

          // 注文情報
          type: "order",
          orderedAt: new Date().toISOString(),

          customer: {
            name: this.formData.name,
            nameKana: this.formData.nameKana,
            email: this.formData.email,
            phone: this.formData.phone,
            postcode: this.formData.postcode,
            prefecture: this.formData.prefecture,
            city: this.formData.city,
            street: this.formData.street,
            building: this.formData.building,
          },

          shop: {
            shop: this.formData.shop,
            otherShop: this.formData.otherShop,
            shopName:
              this.formData.shop === "other"
                ? this.formData.otherShop
                : this.shopName,
          },

          totalPrice: this.totalPrice,
          totalPriceNoTax: this.totalPriceNoTax,
          taxAmount: this.taxAmount,

          orderDetailsText: this.orderDetailsText,
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sessionID: this.sessionID,
            data: orderDataToSave,
          }),
        });

        if (!response.ok) {
          const text = await response.text();
          alert(`注文JSONの保存に失敗しました。\n${response.status}\n${text}`);
          return;
        }

        await Promise.all([
          sendMail(MAIL_TYPES.ORDER_CUSTOMER, templateParams),
          sendMail(MAIL_TYPES.ORDER_ADMIN, templateParams),
        ]);

        this.$router.push({ name: "ThanksPage" });
      } catch (error) {
        console.error("[Confirmation] 注文確定処理に失敗しました", error);
        alert("送信に失敗しました。時間をおいて再度お試しください。");
      } finally {
        this.sending = false;
      }
    }
  },
};
</script>

<style scoped>
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 3vw 0;
}
.privacy-link {
  color: #fff;
  text-decoration: underline;
}
.privacy-link:hover {
  color: #ccc;
}
.col {
  padding-right: 5px;
  padding-left: 5px;
}

.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 100%;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form__main {
  max-width: 700px;
}

/* テーブルスタイル */
.delivery-info {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
}

/* 左側（ラベル）のスタイル */
.delivery-info th {
  text-align: left;
  font-weight: bold;
  padding: 8px 0px 4px 12%;
  white-space: nowrap; /* テキストの折り返しを防ぐ */
  color: #fff; /* ラベルの色（必要に応じて変更） */
  vertical-align: top;
  width: 150px;
}

/* 右側（データ）のスタイル */
.delivery-info td {
  padding: 8px 0px 4px 12%;
  color: #fff; /* データの色（必要に応じて変更） */
  overflow-wrap: anywhere;
}

/* 背景色を交互に付ける（オプション） */
.delivery-info tr:nth-child(odd) {
  background-color: transparent; /* 背景をなしに */
}

.delivery-info tr:nth-child(even) {
  background-color: transparent; /* 背景をなしに */
}

/* カードのスタイル */
.card {
  background-color: transparent; /* 背景を透過に */
  border: none; /* カード枠を消す */
  margin: 0;
  padding: 0;
}
h4 {
  color: #fff;
}
.choice-detail {
  border: 1px solid #fff;
}
table {
  width: 100%; /* 親要素いっぱいに広げる */
  border-collapse: collapse; /* セル間の隙間をなくす */
}

.choice-detail th {
  border-bottom: 1px solid #fff;
  /* border-right: 1px solid #fff; */
  text-align: center;
}

.table-price {
  text-align: right;
}

details {
  border: 0px;
  padding-left: 3px;
  margin-top: -10px;
}

.choice-detail th:first-child,
.choice-detail td:first-child {
  width: 70%; /* 商品名の列を70%に設定 */
}

/* 価格の列幅 */
.choice-detail th:last-child,
.choice-detail td:last-child {
  width: 30%; /* 価格の列を30%に設定 */
}

p {
  margin-top: 1rem;
  margin-bottom: 0rem;
}

li {
  list-style: none;
}

@media (max-width: 500px) {
  li {
    font-size: 3vw;
  }
}

@media (max-width: 400px) {
  li {
    font-size: 2.4vw;
  }
  .col {
    padding-left: 2px;
    padding-right: 2px;
  }
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  -webkit-text-fill-color: #fff !important; /* テキスト色を白 */
  box-shadow: 0 0 0px 1000px #000 inset !important; /* 背景を完全に黒で塗りつぶす */
}

/* Firefox用 */
input:-moz-autofill,
textarea:-moz-autofill,
select:-moz-autofill {
  background-color: #000 !important; /* 背景色を黒 */
  color: #fff !important; /* テキスト色を白 */
}

/* :active時の色変更を防ぐ */
.form-btn-block:active {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

/* :focus-visible時の色変更を防ぐ */
.form-btn-block:focus-visible {
  background-color: #fff; /* 背景色を維持 */
  color: #000; /* テキスト色を維持 */
}

.navbar {
  padding: 8px 10px;
}

.confir-border-right {
  border-right: 1px solid #fff;
}

.form__btn_gap {
  gap: 1vw;
  padding: 48px 0 0 0;
}

.form-original {
  margin-bottom: 4px;
}
</style>
